<div ngClass.gt-xs="m-t-24 m-b-24 p-l-24" ngClass.lt-sm="m-t-16 m-b-16 p-l-16" class="full-width"
     fxLayout="row" fxLayoutAlign="flex-start flex-start">
  <mat-icon [svgIcon]="'app-logo'" class="logo"></mat-icon>
</div>
